import { useNavigate } from "react-router-dom";
import BackIcon from "../../assets/images/BackIcon";
import { pageRouteConstants, StaffListConstants } from "../../constants/constants";
import BackIconInBlack from "../../assets/images/BackIconInBlack";
import { useTranslation } from "react-i18next";

export const UserExitFLowTitleComponent = () => {
  const navigate = useNavigate();
const {t,i18n}=useTranslation();
  return (
    <div className="flex">
      {/* <div
        onClick={() => {
          navigate(pageRouteConstants.dashBoardRoute)
        }}
        className="pt-1 pr-4  cursor-pointer "
      >
        <BackIconInBlack />
      </div> */}
      <div className="flex flex-col">
        <div
          className="text"
          style={{ fontFamily: "Lexend, sans-serif", fontWeight: 600 }}
        >
          {t('staffExitFlowTitle')}
        </div>
        <div className="text-primary flex staffListDownloadCheckbox font-nunito">
          <div className="roleButton text-blackColor pt-2">
            {t('staffInformationDescription')}
          </div>
        </div>
      </div>
    </div>
  );
};
